import script from "./work.vue?vue&type=script&setup=true&lang=js"
export * from "./work.vue?vue&type=script&setup=true&lang=js"

import "./work.vue?vue&type=style&index=0&id=efe696ca&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efe696ca"]])

export default __exports__